import React from 'react';
import PropTypes from 'prop-types';
import { noop, has } from 'lodash';

import { StyledContainer } from './styled';

const SelectableItem = props => {
  const {
    ItemComponent,
    count,
    model,
    isSelected,
    isPreSelected,
    updateItem,
    reorderItem,
    onRef,
    index,
    matchedRulesMap,
    toggleItemStatus,
    duplicateItem,
    getRuleMatchedRows,
    ...restProps
  } = props;

  const handleClick = () => props.selectItem(props.model);

  return (
    <StyledContainer
      ref={el => onRef(el, index)}
      data-test="rule-item"
      isGroup={has(model, 'rules')}
      isPreSelected={isPreSelected}
      isSelected={isSelected}
      onClick={handleClick}
    >
      {React.cloneElement(ItemComponent, {
        ...restProps,
        count,
        model,
        isArchived: model.archived,
        index,
        isSelected,
        isPreSelected,
        matchedRulesMap,
        reorderItem,
        toggleItemStatus,
        duplicateItem,
        updateItem,
        getRuleMatchedRows,
      })}
    </StyledContainer>
  );
};

SelectableItem.propTypes = {
  isPreSelected: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  ItemComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  model: PropTypes.shape({
    archived: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  selectItem: PropTypes.func.isRequired,
  onMount: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onUnmount: PropTypes.func.isRequired,
  count: PropTypes.number,
  duplicateItem: PropTypes.func,
  getRuleMatchedRows: PropTypes.func,
  index: PropTypes.number,
  isArchived: PropTypes.bool,
  isReordering: PropTypes.bool,
  matchedRulesMap: PropTypes.shape({}),
  reorderItem: PropTypes.func,
  toggleItemStatus: PropTypes.func,
  updateItem: PropTypes.func,
};

SelectableItem.defaultProps = {
  count: 0,
  isReordering: false,
  matchedRulesMap: {},
  updateItem: noop,
  reorderItem: noop,
  toggleItemStatus: noop,
  duplicateItem: noop,
  getRuleMatchedRows: noop,
};

export default SelectableItem;
